<template>
  <div id="indexRingId">
    <!-- -->
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonRing",
  props: {
    ringData: {
      type: Object,
      default() {
        return {
          list: [],
          color: [],
        };
      },
    },
    innerRingList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },

  mounted() {
    var chartDom = document.getElementById("indexRingId");
    var myChart = this.$echarts.init(chartDom);
    var option;
    let total = this.ringData.list.reduce((total, next) => {
      return total + next.value;
    }, 0);
    console.log(total);
    option = {
      tooltip: {
        trigger: "item",
      },
      color: this.ringData?.color || [],
      series: [
        {
          type: "pie",
          // radius: ["45%", "70%"],
          radius: ["0%", "45%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: true,
            position: "inner",
            formatter(param) {
              console.log(param.data);
              const { value, name } = param.data;
              return name;
            },
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: 40,
          //     fontWeight: "bold",
          //   },
          // },
          labelLine: {
            show: true,
          },
          data: this.ringData?.list?.slice(0, 2) || [] /* || [
            { value: 1048, name: "Search Engine" },
            { value: 735, name: "Direct" },
            { value: 580, name: "Email" },
            { value: 484, name: "Union Ads" },
            { value: 300, name: "Video Ads" },
          ], */,
        },
        {
          name: "科技成果",
          type: "pie",
          selectedMode: "single",
          // radius: [0, "30%"],
          radius: ["50%", "80%"],

          // label: {
          //   position: "inner",
          //   fontSize: 14,
          // },
          data: this.innerRingList || [],
          // [
          //   { value: 1548, name: "Search Engine" },
          //   { value: 775, name: "Direct" },
          //   { value: 679, name: "Marketing", selected: true },
          // ],
        },
      ],
    };

    option && myChart.setOption(option);
  },

  methods: {},
};
</script>
<style lang="less" scoped>
#indexRingId {
  width: 100%;
  height: 100%;
}
</style>